import type {UseFetchOptions} from 'nuxt/app'

const Get = async <T>(url: string, options?: UseFetchOptions<T>) => {
  return await useApiFetch(url, {
    method: 'GET',
    ...options
  })
}

const Post = async <T>(url: string, data?: Record<string, unknown | unknown[]>, options?: UseFetchOptions<T>) => {
  return await useApiFetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options
  })
}

const Patch = async <T>(url: string, data?: Record<string, unknown | unknown[]>, options?: UseFetchOptions<T>) => {
  data = {...data, _method: 'PATCH'}
  return await useApiFetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options
  })
}

const Delete = async <T>(url: string, options?: UseFetchOptions<T>) => {
  return await useApiFetch(url, {
    method: 'DELETE',
    ...options
  })
}

export const authApi = {
  e_login: () => Get('/social/login/e2e'),
  login: (socure: string, params: {code: string}) => Get(`/social/login/${socure}/callback`, {params}),
  logout: () => Post('/logout')
}

const user = '/user'
export const profileApi = {
  getUser: () => Get(user),
  setUser: (data: {type?: string; school?: string; grade?: number}) => Patch(user, data),
  removeUser: () => Delete(user)
}

const perq = '/perq'
export const perqApi = {
  getDomains: () => Get(perq + '/domains'),
  getQuestions: (stage: number) => Get(perq + '/questions', {params: {stage}}),
  stagesAnswers: (stage: number, data: {answers: {code: string; answer: number}[]}) =>
    Post(perq + `/stages/${stage}/answers`, data, {params: {stage}}),
  getHistories: () => Get(perq + '/histories')
}

const counsel = '/counsel'
export const rodinApi = {
  sendCounsel: (data: {prompt: string}) => Post(counsel, data),
  deleteCounsel: () => Delete(counsel),
  getCounsel: () => Get(counsel + `/histories`)
}

const policy = '/policy'
interface LanguageParams {
  lang?: 'ko' | 'en'
}

export const policyApi = {
  terms: (locale?: LanguageParams) => Get(policy + '/terms', {params: {locale}}),
  privacy: (locale?: LanguageParams) => Get(policy + '/privacy', {params: {locale}}),
  location: () => Get(policy + '/location')
}
